module.exports = __webpack_public_path__ + "static/media/contactsOrange.8840a7b0.svg";